import app from "/src/app/app.module";

app.controller('webhook-settings-controller', function ($scope, $api, toastr, vxUtils, $q) {
    // Initialize webhook object
    $scope.webhook = {
        id: null,
        webhook_url: '',
        api_key: '',
        api_key_masked: '',
        is_active: true
    };

    $scope.newApiKey = null;
    $scope.statusMessage = '';
    $scope.showNewKey = false;
    $scope.loading = true;

    /**
     * Load webhook settings on controller init
     */
    const loadWebhookSettings = function () {
        $scope.loading = true;
        $api.get($api.adress.webhookSettings, function (data) {
            $scope.loading = false;
            if (data && data.id) {
                $scope.webhook = {
                    id: data.id,
                    webhook_url: data.webhook_url,
                    api_key: data.api_key || '',
                    api_key_masked: data.api_key_masked || '',
                    is_active: data.is_active == 1 || data.is_active === true || data.is_active === '1'
                };
                // Show the new API key if it was just created
                if (data.api_key && !$scope.webhook.api_key_masked) {
                    $scope.newApiKey = data.api_key;
                }
            } else {
                // No webhook exists
                $scope.webhook = {
                    id: null,
                    webhook_url: data ? data.webhook_url : '',
                    api_key: '',
                    api_key_masked: '',
                    is_active: true
                };
            }
        }, null, function (error) {
            $scope.loading = false;
            console.log('Error loading webhook settings:', error);
        });
    };

    // Load settings on init
    loadWebhookSettings();

    /**
     * Get full webhook URL with API key
     */
    $scope.getFullWebhookUrl = function () {
        if ($scope.webhook.webhook_url && $scope.webhook.api_key) {
            return $scope.webhook.webhook_url + '?api_key=' + $scope.webhook.api_key;
        } else if ($scope.webhook.webhook_url) {
            return $scope.webhook.webhook_url + '?api_key=YOUR_API_KEY';
        }
        return '';
    };

    /**
     * Copy full URL with API key to clipboard
     */
    $scope.copyFullUrl = function () {
        const fullUrl = $scope.getFullWebhookUrl();
        if (fullUrl && $scope.webhook.api_key) {
            const textArea = document.createElement('textarea');
            textArea.value = fullUrl;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            toastr.success(vxUtils.loc('SUCCES'), 'Webhook URL copied to clipboard');
        }
    };

    /**
     * Refresh settings from server
     */
    $scope.refreshSettings = function () {
        loadWebhookSettings();
        toastr.info('Settings refreshed');
    };

    /**
     * Create new webhook with API key
     */
    $scope.createWebhook = function () {
        $api.post($api.adress.webhookSettings, function (response) {
            if (response.success && response.api_key) {
                toastr.success(vxUtils.loc('SUCCES'), 'Webhook created successfully');
                $scope.webhook.id = response.id;
                $scope.webhook.webhook_url = response.webhook_url;
                $scope.newApiKey = response.api_key;
                $scope.webhook.api_key = response.api_key;
                $scope.webhook.is_active = true;
            } else {
                toastr.error('Error', response.message || 'Failed to create webhook');
            }
        }, { is_active: 1 });
    };

    /**
     * Save webhook settings
     */
    $scope.saveWebhook = function () {
        const payload = {
            is_active: $scope.webhook.is_active ? 1 : 0
        };

        if ($scope.webhook.id) {
            // Update existing webhook
            $api.post($api.adress.webhookSettings, function (response) {
                if (response.success) {
                    toastr.success(vxUtils.loc('SUCCES'), vxUtils.loc('CHANGESUCCESFULL'));
                    $scope.statusMessage = response.message;
                    // Reload the webhook settings
                    setTimeout(() => {
                        loadWebhookSettings();
                        $scope.statusMessage = '';
                    }, 2000);
                } else {
                    toastr.error('Error', response.message || 'Failed to update webhook');
                }
            }, payload);
        } else {
            // Create new webhook
            $api.post($api.adress.webhookSettings, function (response) {
                if (response.success && response.api_key) {
                    toastr.success(vxUtils.loc('SUCCES'), 'Webhook created successfully');
                    $scope.webhook.id = response.id;
                    $scope.newApiKey = response.api_key;
                    $scope.showNewKey = true;
                    $scope.statusMessage = response.message;
                    
                    // Load the full webhook details after creation
                    setTimeout(() => {
                        loadWebhookSettings();
                    }, 1000);
                } else {
                    toastr.error('Error', response.message || 'Failed to create webhook');
                }
            }, payload);
        }
    };

    /**
     * Regenerate API key with confirmation
     */
    $scope.regenerateApiKey = function () {
        const confirmed = confirm(vxUtils.loc('REGENERATE_WARNING') + '\n\n' + 
                                  'Are you sure you want to regenerate the API key?');
        
        if (!confirmed) {
            return;
        }

        $api.post($api.adress.webhookSettingsRegenerateKey, function (response) {
            if (response.success && response.api_key) {
                toastr.success(vxUtils.loc('SUCCES'), 'API key regenerated successfully');
                $scope.newApiKey = response.api_key;
                $scope.showNewKey = true;
                $scope.statusMessage = response.message;
                
                // Reload settings after regeneration
                setTimeout(() => {
                    loadWebhookSettings();
                }, 1500);
            } else {
                toastr.error('Error', response.message || 'Failed to regenerate API key');
            }
        }, {});
    };

    /**
     * Delete webhook
     */
    $scope.deleteWebhook = function () {
        const confirmed = confirm('Are you sure you want to delete this webhook? This action cannot be undone.');
        
        if (!confirmed) {
            return;
        }

        $api.del($api.adress.webhookSettings, function (response) {
            if (response.success) {
                toastr.success(vxUtils.loc('SUCCES'), 'Webhook deleted successfully');
                // Reset form
                $scope.webhook = {
                    webhook_url: '',
                    api_key: '',
                    api_key_masked: '',
                    is_active: true
                };
                $scope.newApiKey = null;
                $scope.statusMessage = '';
            } else {
                toastr.error('Error', response.message || 'Failed to delete webhook');
            }
        });
    };

    /**
     * Copy webhook URL to clipboard
     */
    $scope.copyToClipboard = function (field) {
        const element = document.getElementById(field);
        if (element) {
            element.select();
            document.execCommand('copy');
            toastr.info('Copied to clipboard');
        }
    };

    /**
     * Copy API key to clipboard (masked version)
     */
    $scope.copyApiKey = function () {
        if ($scope.webhook.api_key) {
            const textArea = document.createElement('textarea');
            textArea.value = $scope.webhook.api_key;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            toastr.success('API key copied to clipboard');
        }
    };

    /**
     * Copy newly generated API key
     */
    $scope.copyNewApiKey = function () {
        if ($scope.newApiKey) {
            const textArea = document.createElement('textarea');
            textArea.value = $scope.newApiKey;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            toastr.success('New API key copied to clipboard');
        }
    };

    /**
     * Copy example curl command
     */
    $scope.copyExample = function () {
        const example = `curl -X POST "${$scope.getFullWebhookUrl()}" \\
  -H "Content-Type: application/x-www-form-urlencoded" \\
  -d "Naam=John&Email=john@example.com&Telefoon=+31612345678&Bericht=Test+message"`;
        
        const textArea = document.createElement('textarea');
        textArea.value = example;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        toastr.success('Example copied to clipboard');
    };
});
